import { createContext } from "react";

const ScreenReaderAlertContext = createContext();

export default ScreenReaderAlertContext;
